import React, { memo } from 'react';
import { Demonstration } from '../services/api';
import VideoThumbnail from './VideoThumbnail';
import './DemonstrationCard.css';

interface DemonstrationCardProps {
  demonstration: Demonstration;
  onSelect: (demonstration: Demonstration) => void;
  showMove?: boolean;
}

const DemonstrationCard = memo<DemonstrationCardProps>(({
  demonstration,
  onSelect,
  showMove = true
}) => {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <div className="demonstration-card">
      <VideoThumbnail
        videoUrl={demonstration.videoUrl}
        thumbnailUrl={demonstration.thumbnail}
        alt={`${demonstration.dancer?.name}'s demonstration`}
        onClick={() => onSelect(demonstration)}
      />

      <div className="demonstration-info">
        <div className="demonstration-header">
          <div className="dancer-info">
            {demonstration.dancer?.profileImage ? (
              <img
                src={demonstration.dancer.profileImage}
                alt={demonstration.dancer.name}
                className="dancer-avatar"
              />
            ) : (
              <div className="dancer-avatar-placeholder">
                {demonstration.dancer?.name?.charAt(0) || '?'}
              </div>
            )}
            <span className="dancer-name">{demonstration.dancer?.name}</span>
          </div>
          {demonstration.isFeatured && (
            <span className="featured-badge">Featured</span>
          )}
        </div>

        {showMove && demonstration.move && (
          <h4 className="demonstration-move">{demonstration.move.title}</h4>
        )}

        {demonstration.caption && (
          <p className="demonstration-caption">{demonstration.caption}</p>
        )}

        <div className="demonstration-meta">
          <span className="demonstration-date">{formatDate(demonstration.createdAt)}</span>
          {demonstration.feedback && demonstration.feedback.length > 0 && (
            <span className="feedback-count">
              {demonstration.feedback.length} comment{demonstration.feedback.length !== 1 ? 's' : ''}
            </span>
          )}
        </div>
      </div>
    </div>
  );
});

DemonstrationCard.displayName = 'DemonstrationCard';

export default DemonstrationCard;
